import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Grid } from '@xsolla/ui-core';

import { PROJECT_LINKS } from '../../../constants';
import { useConfig } from '../../../contexts/config';
import { hrefTo } from '../../../utils';
import { HelpCard } from '../../index';
import { CommentIcon, DocumentIcon, LightBulbIcon, LinkStyles } from '../../ui';

const HelpHeader = styled.div`
  text-align: center;
  width: 100%;
  margin-bottom: 44px;
  color: ${(p) => p.theme.colors.text};
  ${(p) => p.theme.typography.title}
`;

const HelpSteps = (): JSX.Element => {
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();

  const linkOnClick = useCallback((link: string) => {
    xsollaAnalytics.sendExternalLink(`login_pa_module__dashboard__external_link`, link);
  }, []);

  const helpContactUs = (
    <LinkStyles>
      <FormattedMessage
        id="dashboard.help.ask.text-contact"
        values={hrefTo({ href: 'mailto:integration@xsolla.com', onClick: linkOnClick })}
      />
      <br />
      <FormattedMessage
        id="dashboard.help.ask.text-feedback"
        values={hrefTo({ href: 'mailto:onboarding@xsolla.com', onClick: linkOnClick })}
      />
    </LinkStyles>
  );

  /*
  // Добавить внутрь самих меток ссылки и тогда использовать этот код. Временно сделана ссылка на весь текст
  const helpFAQ = (
    <LinkStyles>
      <FormattedMessage
        id="dashboard.help.faq.text"
        values={hrefTo(`${config.docLink}/references/faq/`, linkOnClick)}
      />
    </LinkStyles>
  );

  const helpDoc = (
    <LinkStyles>
      <FormattedMessage
        id="dashboard.help.documentation.text"
        values={hrefTo(config.docLink, linkOnClick)}
      />
    </LinkStyles>
  );
   */

  const helpFAQ = (
    <LinkStyles>
      <a href={`${PROJECT_LINKS.DOCUMENTATION}/references/faq/`} target="_blank" rel="noreferrer">
        {intl.formatMessage({ id: 'dashboard.help.faq.text' })}
      </a>
    </LinkStyles>
  );

  const helpDoc = (
    <LinkStyles>
      <a href={PROJECT_LINKS.DOCUMENTATION} target="_blank" rel="noreferrer">
        {intl.formatMessage({ id: 'dashboard.help.documentation.text' })}
      </a>
    </LinkStyles>
  );

  return (
    <>
      <HelpHeader>{intl.formatMessage({ id: 'dashboard.help.label' })}</HelpHeader>

      <Grid allowOverflow cols={3} gap={16}>
        <HelpCard
          title={intl.formatMessage({ id: 'dashboard.help.faq.label' })}
          content={helpFAQ}
          icon={<LightBulbIcon />}
        />
        <HelpCard
          title={intl.formatMessage({ id: 'dashboard.help.documentation.label' })}
          content={helpDoc}
          icon={<DocumentIcon />}
        />
        <HelpCard
          title={intl.formatMessage({ id: 'dashboard.help.ask.label' })}
          content={helpContactUs}
          icon={<CommentIcon />}
        />
      </Grid>
    </>
  );
};

export default HelpSteps;
